import { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid2,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import Colors from "../../assets/styles";
import { useForm } from "react-hook-form";
import AuthServices from "../../apis/AuthServices";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";
import { useNavigate } from "react-router-dom";

export default function AddStation() {
  const [stations, setStations] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();

  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      stationName: "",
      stationNameUr: "",
      city: "",
      latitude: "",
      longitude: "",
    },
  });

  const onSubmit = (formData) => {
    const obj = {
      StationName: formData?.stationName,
      StationNameUR: formData?.stationNameUr,
      City: formData?.city,
      Latitude: formData?.latitude ? Number(formData.latitude) : null,
      Longitude: formData?.longitude ? Number(formData.longitude) : null,
      IsActive: isActive,
      IsDeleted: false,
    };

    setStations([...stations, obj]);
    reset();
    setIsActive(true);
  };

  const handleDelete = (index) => {
    setStations((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    try {
      let result = await AuthServices.addStation(stations);
      if (typeof result === "string") {
        try {
          result = JSON.parse(result);
        } catch (e) {
          ErrorToaster(result);
          return;
        }
      }
      const saved = Array.isArray(result?.Response) && result.Response.length > 0;
      if (result?.IsSuccess === true && saved) {
        SuccessToaster("Station Added Successfully");
        navigate("/station-list");
      } else {
        const message =
          result?.ErrorMessage ||
          (typeof result?.Response === "string" ? result.Response : "") ||
          "Station was not saved";
        ErrorToaster(message);
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };

  return (
    <Box sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderColor: "divider",
          mb: 1,
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            color: Colors.primary,
            fontWeight: 500,
            letterSpacing: "1px",
          }}
        >
          ADD STATION
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          STATION / ADD STATION
        </Typography>
      </Box>

      <Card sx={{ mb: 4, borderRadius: "12px" }}>
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            color: Colors.primary,
            borderColor: "divider",
          }}
        >
          <Typography variant="h6">STATION DETAILS</Typography>
        </Box>
        <CardContent>
          <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={2} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Station Name
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Enter Station Name"
                  {...register("stationName", {
                    required: "Station Name is Required",
                  })}
                  error={!!errors.stationName}
                  helperText={errors.stationName ? errors.stationName.message : ""}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Station Name (Urdu)
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Enter Station Name (Urdu)"
                  {...register("stationNameUr")}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  City
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Enter City"
                  {...register("city", { required: "City is Required" })}
                  error={!!errors.city}
                  helperText={errors.city ? errors.city.message : ""}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Latitude
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  inputProps={{ step: "any" }}
                  placeholder="Enter Latitude"
                  {...register("latitude")}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Longitude
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  inputProps={{ step: "any" }}
                  placeholder="Enter Longitude"
                  {...register("longitude")}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Status
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isActive}
                      onChange={(event) => setIsActive(event.target.checked)}
                    />
                  }
                  label="Is Active"
                />
              </Grid2>

              <Grid2
                size={{ xs: 12, md: 12 }}
                sx={{ display: "flex", alignItems: "flex-end" }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    bgcolor: "#133e02",
                    "&:hover": {
                      bgcolor: "green.800",
                    },
                  }}
                >
                  <AddIcon />
                </Button>
              </Grid2>
            </Grid2>
          </Box>
        </CardContent>
      </Card>

      <Card sx={{ borderRadius: "12px" }}>
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            borderColor: "divider",
            color: Colors.primary,
          }}
        >
          <Typography variant="h6">ADDED STATION LIST</Typography>
        </Box>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#133e02" }}>
                  <TableCell sx={{ color: "white" }}>#</TableCell>
                  <TableCell sx={{ color: "white" }}>Station Name</TableCell>
                  <TableCell sx={{ color: "white" }}>Station Name (Urdu)</TableCell>
                  <TableCell sx={{ color: "white" }}>City</TableCell>
                  <TableCell sx={{ color: "white" }}>Latitude</TableCell>
                  <TableCell sx={{ color: "white" }}>Longitude</TableCell>
                  <TableCell sx={{ color: "white" }}>Active</TableCell>
                  <TableCell sx={{ color: "white" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stations.map((station, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{station.StationName}</TableCell>
                    <TableCell>{station.StationNameUR}</TableCell>
                    <TableCell>{station.City}</TableCell>
                    <TableCell>{station.Latitude ?? "-"}</TableCell>
                    <TableCell>{station.Longitude ?? "-"}</TableCell>
                    <TableCell>{station.IsActive ? "Yes" : "No"}</TableCell>
                    <TableCell>
                      <DeleteIcon
                        onClick={() => handleDelete(index)}
                        sx={{ cursor: "pointer" }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {stations.length > 0 && (
            <Button
              variant="contained"
              sx={{
                mt: 2,
                bgcolor: "rgb(19 62 2)",
                "&:hover": {
                  bgcolor: "rgb(19 62 2)",
                },
              }}
              onClick={handleSave}
            >
              Save
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
